import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';
import { IPostIssueReportRequestBody } from '@types';

async function postIssueReport(variables: IPostIssueReportRequestBody): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.post(`/images/${variables.imageId}/issue-reports`, {
    reportContent: variables.reportContent
  });
  return response;
}

const usePostIssueReport = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending } = useMutation({
    mutationKey: ['post', '/images/:id/issue-reports'],
    mutationFn: (variables: IPostIssueReportRequestBody) => postIssueReport(variables),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending };
};

export default usePostIssueReport;
